import CartPlansPageV2 from './CartPlansPageV2'

export default CartPlansPageV2
// eslint-disable-next-line import/export
export * from './CartPlansPageV2'
